import { PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";
import { call, put } from "redux-saga/effects";
import { Money } from "../../../../services/reddyApi/Money/Money";
import handleServerError from "../../all/saga/handleServerError";
import setServerErrorDefault from "../../all/saga/setServerErrorDefault";
import { getVendorMoneyTransactionsFetch, getVendorMoneyTransactionsSuccess } from "../finance.slice";
import { GetVendorMoneyTransactionsPayload } from "../payload/GetVendorMoneyTransactions/GetVendorMoneyTransactionsPayload";

function* getVendorMoneyTransactionsWorker(action: PayloadAction<GetVendorMoneyTransactionsPayload>) {
    const { vendorId, filter } = action.payload;
    const dataParams = {
        vendorId,
        filter,
    }

    try {
        const { data } = yield call(Money.getVendorMoneyTransactions, dataParams);
        const { items, totalCount } = data;

        yield put(getVendorMoneyTransactionsSuccess({ items, totalCount, filter }));

        yield setServerErrorDefault();
    } catch (error) {
        if (axios.isAxiosError(error)) {
            const actionCreator = () => getVendorMoneyTransactionsFetch(action.payload);

            yield handleServerError(error, actionCreator);
        }
    }
}

export default getVendorMoneyTransactionsWorker;